import React, { Component } from "react";
import anime from "animejs";
import PropTypes from "prop-types";
import classNames from "classnames";
import VimeoPlayer from "~/scripts/components/VimeoPlayer";
import Captions from "~/scripts/components/Captions";
import Logo from "~/scripts/elements/Logo";
import { isMobile } from "~/scripts/utils/is-mobile";
import { w } from "~/scripts/utils/w";

const CLASS_HEADER_HIDDEN = "is-header-hidden";
const CLASS_SOUND_ON = "is-sound-on";

class RollHeader extends Component {
    static propTypes = {
        posY: PropTypes.number.isRequired,
        line1: PropTypes.string,
        line2: PropTypes.string,
        showReelUrl: PropTypes.string
    };

    whOld = 0;
    hOld = 0;

    state = {
        muted: true,
        isHeaderHiddenMobile: false
    };

    constructor(props) {
        super(props);

        this.headerRef = React.createRef();
        this.video = React.createRef();
        this.wave = React.createRef();
        this.w = w();
        // this.handleResize = debounce(this.handleResize, 250);
    }

    componentDidMount() {
        window.addEventListener("load", this.handleResize);
        window.addEventListener("resize", this.handleResize);
        this.handleResize();

        if (isMobile) {
            window.addEventListener("scroll", this.handleScroll);
            this.handleScroll();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("load", this.handleResize);
        window.removeEventListener("resize", this.handleResize);

        if (isMobile) {
            window.removeEventListener("scroll", this.handleScroll);
        }
    }

    handleScroll = () => {
        const { pageYOffset } = window;
        const { isHeaderHiddenMobile } = this.state;

        if (pageYOffset >= this.w.h / 4 && !isHeaderHiddenMobile) {
            this.setState({
                isHeaderHiddenMobile: true
            });
        }

        if (pageYOffset < this.w.h / 4 && isHeaderHiddenMobile) {
            this.setState({
                isHeaderHiddenMobile: false
            });
        }
    };

    handleResize = () => {
        const height = this.headerRef.current.clientHeight;

        if (
            (this.w.h !== 0 && Math.abs(this.whOld - this.w.h) > 100) ||
            this.hOld !== height
        ) {
            this.whOld = this.w.h;
            this.hOld = height;

            const pt = (this.w.h - height) / 2;

            this.setState({
                paddingTop: pt > 60 ? pt : 60
            });
        }
    };

    soundsToggle = () => {
        const { muted } = this.state;

        if (muted) {
            anime({
                targets: this.wave.current,
                d: [
                    "M0,3 C10,3 10,15 20,15 C30,15 30,3 40,3 C50,3 50,15 60,15 C70,15 70,3 80,3 C90,3 90,15 100,15 C110,15 110,3 120,3 C130,3 130,15 140,15 C150,15 150,3 160,3"
                ],
                easing: "easeOutQuad",
                duration: 500
            });
        } else {
            anime({
                targets: this.wave.current,
                d: [
                    "M0,9 C10,9 10,11 20,11 C30,11 30,9 40,9 C50,9 50,11 60,11 C70,11 70,9 80,9 C90,9 90,11 100,11 C110,11 110,9 120,9 C130,9 130,11 140,11 C150,11 150,9 160,9"
                ],
                easing: "easeOutQuad",
                duration: 500
            });
        }

        this.setState({
            muted: !muted
        });
    };

    handlePlay = () => {
        this.setState({ played: true });
    };

    render() {
        const {
            line1,
            line2,
            showReelUrl,
            posY,
            scrollLocked,
            poster
        } = this.props;
        const { muted, paddingTop, played, isHeaderHiddenMobile } = this.state;

        let isHeaderHidden = false;
        let y = null;
        // let paddingTop = null;

        if (this.headerRef.current) {
            // const rect = this.headerRef.current.getBoundingClientRect();
            // const progress = (1 - (rect.top + rect.height) / (this.w.h + rect.height));

            // paddingTop = (this.w.h - rect.height) / 2;
            // console.log(this.w.h, rect.height);
            // const progress = 1 - (rect.top + rect.height) / (this.w.h + rect.height);

            if (!scrollLocked) {
                y = isMobile ? null : -posY * 0.1;
            }

            // y = isMobile ? 0 : (1 - progress*2) * 100;
            // isHeaderHidden = progress > 0.75;
            isHeaderHidden = isMobile
                ? isHeaderHiddenMobile
                : posY >= this.w.h / 4;
            // console.log(isHeaderHidden);
        }

        return (
            <div
                className={classNames("roll-header", {
                    [CLASS_HEADER_HIDDEN]: isHeaderHidden
                })}
                style={{
                    marginTop: paddingTop ? `${paddingTop}px` : ""
                }}
            >
                <div
                    ref={this.headerRef}
                    className={classNames("roll-header__inner", {
                        [CLASS_SOUND_ON]: !muted
                    })}
                >
                    <div
                        className="roll-header__logo"
                        style={{
                            transform: y
                                ? `translate3d(0, ${y * 3.5}px, 0)`
                                : ""
                        }}
                    >
                        <Logo />
                    </div>
                    <div
                        className="roll-header__showreel"
                        style={{
                            transform: y ? `translate3d(0, ${y}px, 0)` : ""
                        }}
                    >
                        <div
                            className={classNames("roll-header__video", {
                                loaded: played
                            })}
                        >
                            {poster && (
                                <div className="roll-header__preview-container">
                                    <img
                                        className="roll-header__preview-image"
                                        src={poster.thumb}
                                        alt={`${line1} - ${line2}`}
                                    />
                                </div>
                            )}
                            {showReelUrl && (
                                <VimeoPlayer
                                    url={showReelUrl}
                                    background={true}
                                    loop={true}
                                    playing={!isHeaderHidden}
                                    muted={muted}
                                    onPlay={this.handlePlay}
                                />
                            )}

                            <span
                                className={classNames("roll-header__loading", {
                                    loaded: played
                                })}
                            >
                                <svg viewBox="25 25 50 50">
                                    <circle
                                        cx="50"
                                        cy="50"
                                        r="20"
                                        fill="none"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                    />
                                </svg>
                            </span>

                            <div
                                className="roll-header__sound"
                                onClick={this.soundsToggle}
                            >
                                <div className="roll-header__wave">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 160 18"
                                    >
                                        <path
                                            ref={this.wave}
                                            fill="none"
                                            stroke="none"
                                            strokeMiterlimit="10"
                                            strokeWidth="2"
                                            d="M0,9 C10,9 10,11 20,11 C30,11 30,9 40,9 C50,9 50,11 60,11 C70,11 70,9 80,9 C90,9 90,11 100,11 C110,11 110,9 120,9 C130,9 130,11 140,11 C150,11 150,9 160,9"
                                        />
                                    </svg>
                                </div>
                            </div>

                            <div className="roll-header__caption">
                                <Captions line1={line1} line2={line2} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RollHeader;



// WEBPACK FOOTER //
// ./src/scripts/components/RollHeader.js